import apiClient from "./apiClient";

export interface EegUploadCapabilities {
  storage_provider: string;
  direct_browser_upload: boolean;
  resumable_upload: boolean;
  content_reuse?: boolean;
  public_upload_origin?: string | null;
  overlay_mtu_candidates?: number[];
  overlay_tcp_mss_clamp?: boolean;
}

let cachedCapabilities: EegUploadCapabilities | null = null;
let capabilitiesPromise: Promise<EegUploadCapabilities> | null = null;

const DEFAULT_CAPABILITIES: EegUploadCapabilities = {
  storage_provider: "unknown",
  direct_browser_upload: false,
  resumable_upload: true,
};

export async function getEegUploadCapabilities(): Promise<EegUploadCapabilities> {
  if (cachedCapabilities) {
    return cachedCapabilities;
  }
  if (!capabilitiesPromise) {
    capabilitiesPromise = apiClient
      .get<{ data?: EegUploadCapabilities }>("/eeg/upload/capabilities")
      .then((response) => {
        const capabilities = response.data?.data;
        if (
          !capabilities ||
          typeof capabilities.direct_browser_upload !== "boolean"
        ) {
          return DEFAULT_CAPABILITIES;
        }
        cachedCapabilities = capabilities;
        return capabilities;
      })
      .catch(() => DEFAULT_CAPABILITIES)
      .finally(() => {
        capabilitiesPromise = null;
      });
  }
  return capabilitiesPromise;
}

export function clearEegUploadCapabilitiesCache(): void {
  cachedCapabilities = null;
  capabilitiesPromise = null;
}

export async function supportsDirectBrowserEegUpload(): Promise<boolean> {
  const capabilities = await getEegUploadCapabilities();
  return capabilities.direct_browser_upload === true;
}
